import { useState } from 'react';
import DocumentRow from './DocumentRow';
import { FileText } from 'lucide-react';

export default function DocumentList({ documents, loading, onDelete, projectId, selectedDocs, onSelectionChange, deletingDocuments }) {
  const handleSelectAll = (checked) => {
    if (checked) {
      onSelectionChange(new Set(documents.map(d => d.id)));
    } else {
      onSelectionChange(new Set());
    }
  };

  const handleSelectDoc = (docId, checked) => {
    const newSelected = new Set(selectedDocs);
    if (checked) {
      newSelected.add(docId);
    } else {
      newSelected.delete(docId);
    }
    onSelectionChange(newSelected);
  };

  const allSelected = documents.length > 0 && selectedDocs.size === documents.length;
  const someSelected = selectedDocs.size > 0 && selectedDocs.size < documents.length;

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600 dark:border-emerald-500 mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400">Loading documents...</p>
        </div>
      </div>
    );
  }

  if (documents.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 px-4">
        <div className="w-16 h-16 bg-gray-100 dark:bg-slate-800 rounded-full flex items-center justify-center mb-4">
          <FileText className="w-8 h-8 text-gray-400 dark:text-gray-500" />
        </div>
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">No documents yet</h3>
        <p className="text-gray-600 dark:text-gray-400 text-center max-w-md">
          Upload PDF documents to start detecting and redacting PII information.
        </p>
      </div>
    );
  }

  return (
    <div>
      {/* Header Row with Select All */}
      <div className="flex items-center gap-4 px-6 py-3 bg-gray-50 dark:bg-slate-800/50 border-b border-gray-200 dark:border-dark-border">
        <div className="flex-shrink-0">
          <input
            type="checkbox"
            checked={allSelected}
            ref={input => {
              if (input) input.indeterminate = someSelected;
            }}
            onChange={(e) => handleSelectAll(e.target.checked)}
            className="w-4 h-4 rounded border-gray-300 dark:border-gray-600 text-emerald-600 focus:ring-emerald-500 dark:bg-slate-700"
          />
        </div>
        <div className="flex-1 text-sm font-medium text-gray-700 dark:text-gray-300">
          {selectedDocs.size > 0 ? `${selectedDocs.size} selected` : 'Select all'}
        </div>
      </div>

      {/* Document Rows */}
      <div className="divide-y divide-gray-200 dark:divide-dark-border">
        {documents.map((document) => (
          <DocumentRow
            key={document.id}
            document={document}
            onDelete={onDelete}
            projectId={projectId}
            isSelected={selectedDocs.has(document.id)}
            onSelect={handleSelectDoc}
            isDeleting={deletingDocuments?.has(document.id)}
          />
        ))}
      </div>
    </div>
  );
}
